const resultsContainer = "mb-4 shrink-0";

const resultsHeader = "pb-3";

const resultsTitle = "text-base flex items-center gap-2";

const successCount = "flex items-center gap-1 text-success";

const failureCount = "flex items-center gap-1 text-destructive";

const resultsContent = "pt-0";

const resultsItemName = "font-medium truncate min-w-0";

export { resultsContainer, resultsHeader, resultsTitle, successCount, failureCount, resultsContent, resultsItemName };
